<template>
  <Layout>
    <div name="login" class="forgot-pass">
      <p>Please contact an admin member to reset your password.</p>
      <p class="center pop-out">+32 9 12 34 56</p>
    </div>
    <router-link class="center underline" to="/login">Go back</router-link>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Authentication.vue'

export default {
  name: 'Forgot Password',
  components: { Layout },
}
</script>

<style lang="scss" scoped>
.forgot-pass {  
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 160px;
  margin: 50px 0;
}
</style>
